import { gql } from "@apollo/client";

export const GET_TOKENIZATION_BY_ORGANIZATION_ID = gql`
  query GetAllOrganizationTokens($payload: JSON!) {
    getAllOrganizationTokens(payload: $payload)
  }
`;
